import Axios from 'axios'
import Vue from 'vue'
import $config from '@/config/js/config.js'
const that = new Vue()
const base = $config.API
const instance = Axios.create({
  headers: {
    'Content-Type': 'application/json'
  },
  baseURL: base
})
// 请求拦截器
instance.interceptors.request.use(
  config => {
    let token = $config.getStorageInfo('token');
    if (token) {
      // config.headers.Authorization = token
      config.headers['NFA-Authorization'] = token;
    }
    return config
  },
  err => {
    that.$message.error('网络错误')
    return Promise.reject(err)
  })

// 响应拦截器
instance.interceptors.response.use(
  response => {
    if (response.status === 200) {
      // console.log(response, '38')
    } else {
      console.log(response.data.message)
      that.$message.error(response.data.message)
    }
    return response
  },
  error => {
    // console.log(error, 'error');
    // console.log(error.response, 'error');
    // console.log(error.response.data, 'error.response.data');
    // console.log(error.response.data.message, 'error.response.data.message');
    // console.log(error.message, 'error。message');
    // console.log(error.response, 'error.response');
    // console.log(error.response.data.status,'404 code');
    if (error.response) {
      if (error.response.status === 403) {
        console.log('无权限')

        if($config.getStorageInfo('token')){
          that.$message.error('无权限,请重新登录');
        }else{
          that.$message.error('请退出后，重新进入');
        }
        // $config.delAllStorageInfo()

      } else if (error.response.data.message) {
        // console.log(error.response.data.message);
        // fail
        that.$message.error(error.response.data.message)
      } else {
        // console.log(error.response.data.error);
        that.$message.error(error.response.data.error)
      }
    } else {
      console.log(error.message)
      that.$message.error(error.message)
    }
    return Promise.reject(error)
  })
const sendAjax = async (method, url, par) => {
  let data,params
  method = method.toLowerCase()
  if (!par) params = {}
  if (method.indexOf('get') >= 0) {
    data = {}
    params = par
  } else {
    data = par
  }
  try {
    const res = await instance.request({
      url,
      method,
      params,
      data
    })
    return res
  } catch (error) {
    // error.response.data.message
    return Promise.reject(error)
  }
}
export default sendAjax
